export const NOTIFY_KEYS = {
  MESSAGE: 'MESSAGE',
  ORDERS: 'ORDERS',
};
